import { Particle } from "../particle";
import { colorConstant, hold, lerp, linearMotion, randomAngle, randomBetween } from "../interpolation";

export class SolidifyBurstParticle extends Particle {
	constructor(originX: number, originY: number) {
		const angle = randomAngle();
		const speed = randomBetween(1.0, 2.5);
		const vx = Math.cos(angle) * speed;
		const vy = Math.sin(angle) * speed;

		const r = randomBetween(80, 160);
		const g = randomBetween(220, 255);
		const b = randomBetween(80, 160);

		super(originX, originY, {
			ttl: randomBetween(200, 350),
			size: lerp(0.35, 0.1),
			opacity: hold(0.8, 0.6, lerp(0.8, 0.0)),
			color: colorConstant(r, g, b),
			rotation: lerp(0, randomBetween(-2, 2)),
			position: linearMotion(vx, vy),
		});
	}
}
